import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";

import { setScale } from "../features/ui/uiSlice";

import { checkStudent, fetchStudent } from "../features/student/studentSlice";

import { BASE_WIDTH } from "../constants/baseInfo";

import TopNavBar from "../components/TopNavBar";
import AssignmentTable from "../features/assignment/components/AssignmentTable";
import FinishedAssignmentTable from "../features/assignment/components/FinishedAssignmentTable";
import PaperAssignmentTable from "../features/paper-assignment/components/PaperAssignmentTable";
import "./HomePage.css";

// 메뉴는 주소로 구분한다. name 이 그대로 /<name> 이 된다.
export const TAB_LIST = [
  {
    name: "paper-assignment",
    text: "알림장 및 과제",
  },
  {
    name: "unfinished",
    text: "미완료 과제",
  },
  {
    name: "finished",
    text: "완료 과제 목록",
  },
];

const DEFAULT_TAB_NAME = "paper-assignment";

// 알림톡으로 이미 나간 링크가 /home?session=... 이라 그 주소도 계속 살아 있어야 한다.
// App.js 의 HomeRedirect 가 여기로 넘긴다.
export const DEFAULT_TAB_PATH = `/${DEFAULT_TAB_NAME}`;

export const buildTabPath = (tabName, search) => `/${tabName}${search}`;

const HomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { topTab } = useParams();
  const { isAuthenticated } = useSelector((state) => state.student);
  const [inWebView, setInWebView] = useState(false);

  const isKnownTab = TAB_LIST.some((tab) => tab.name === topTab);
  // 세션은 쿼리스트링에 있으므로 메뉴를 옮길 때 그대로 들고 간다.
  const selectTab = (tabName) => navigate(buildTabPath(tabName, location.search));

  const isWebView = () => {
    const userAgent = window.navigator.userAgent || "";
    return /FBAN|FBAV|Instagram|Line|KAKAOTALK|wv/i.test(userAgent);
  };

  const openExternalBrowser = () => {
    const url = window.location.href;
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/iPhone|iPad|iPod/.test(userAgent)) {
      // iOS: 카카오톡 외부 브라우저로 열기
      window.location.href = `kakaotalk://web/openExternal?url=${encodeURIComponent(
        url
      )}`;
    } else {
      // Android: 기본 브라우저에서 열기
      window.location.href = `intent://${url.replace(
        /^https?:\/\//,
        ""
      )}#Intent;scheme=https;package=com.android.chrome;end;`;
    }
  };

  useEffect(() => {
    // 화면 폭 기준 모바일 판정 — 최초 1회 + 회전/리사이즈 시 갱신
    const updateScale = () => {
      const currentWidth = window.innerWidth;
      const scaleX = currentWidth / BASE_WIDTH;
      dispatch(setScale(scaleX));
    };
    updateScale();
    window.addEventListener("resize", updateScale);
    window.addEventListener("orientationchange", updateScale);

    const queryParams = new URLSearchParams(window.location.search);
    const session = queryParams.get("session");

    if (session) {
      try {
        const decoded = atob(session);
        const [id, randomCode] = decoded.split(":");
        dispatch(checkStudent({ studentId: id, randomCode: randomCode }));
        setInWebView(isWebView());
        if (isWebView()) {
          openExternalBrowser();
        }
      } catch (error) {
        alert("잘못된 URL입니다.");
      }
    } else {
      alert("잘못된 URL입니다.");
    }
    return () => {
      window.removeEventListener("resize", updateScale);
      window.removeEventListener("orientationchange", updateScale);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    if (isAuthenticated) {
      const queryParams = new URLSearchParams(window.location.search);
      const session = queryParams.get("session");

      if (session) {
        try {
          const decoded = atob(session);
          const [id, randomCode] = decoded.split(":");
          dispatch(fetchStudent({ studentId: id, randomCode: randomCode }));
        } catch (error) {
          alert("잘못된 URL입니다.");
        }
      } else {
        alert("잘못된 URL입니다.");
      }
    }
  }, [isAuthenticated, dispatch]);

  // 없는 메뉴 주소로 들어오면 기본 메뉴로 돌린다. 훅을 다 부른 뒤에 판정한다.
  if (!isKnownTab) {
    return <Navigate to={`${DEFAULT_TAB_PATH}${location.search}`} replace />;
  }

  return (
    <div className="student-page">
      {inWebView && (
        <div className="student-page__webview-notice">
          <button
            className="student-page__webview-button"
            onClick={openExternalBrowser}
          >
            기본 브라우저에서 열기
          </button>
        </div>
      )}
      {!inWebView && isAuthenticated ? (
        <div>
          <TopNavBar topTab={topTab} selectTab={selectTab} tabList={TAB_LIST} />
          {topTab === "unfinished" && <AssignmentTable />}
          {topTab === "finished" && <FinishedAssignmentTable />}
          {topTab === "paper-assignment" && <PaperAssignmentTable />}
        </div>
      ) : (
        <p></p>
      )}
    </div>
  );
};

export default HomePage;
